import React from "react";
import { useMutation } from "react-query";
import { updateCustomReport } from "../../../../actions/Utilities/CustomReport";

const useEditCustomReport = () => {
  return useMutation(updateCustomReport);
};

export default useEditCustomReport;
